<template>
  <v-app :style="{background: 'white'}">
    <Navigation v-if="$store.getters.loggedIn"></Navigation>
    <v-main>
      <div
        class="page bg-image pa-xs-0 pa-sm-12 ma-0"
        :style="{backgroundImage: 'url(' + backgroundImage + ')'}">
        <div class="page">
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import Navigation from './components/Navigation.vue';

// const loginImage1 = require('./assets/login_physics.jpg');
// const loginImage2 = require('./assets/login_chemistry.jpg');
// const loginImage3 = require('./assets/login_dna.jpg');
// const loginImage4 = require('./assets/login_lightbulbs.png');
// const loginImage5 = require('./assets/login_microscope.png');
// const loginImage6 = require('./assets/login_crystals.png');

export default {
  name: 'App',
  components: { Navigation },
  data: () => ({
    // backgroundImages: [
    //   loginImage1,
    //   loginImage2,
    //   loginImage3,
    //   loginImage4,
    //   loginImage5,
    //   loginImage6,
    // ],
    backgroundImageUrl: '',
  }),
  computed: {
    backgroundImage() {
      return this.$store.getters.loggedIn ? '' : this.backgroundImageUrl;
    },
  },
  created() {
    console.log('app entry created.');
    this.checkAuth();
    console.log('Labs.vue :: created :: update_authorizations');
    this.$store.dispatch('updateAuthorizations');
  },
  mounted() {
    console.log('app entry mounted.');
    // const index = Math.floor(Math.random() * Math.floor(this.backgroundImages.length));
    // this.backgroundImageUrl = this.backgroundImages[index];
  },
  methods: {
    checkAuth() {
      const url = 'https://portal.beyondlabz.com/portal/auth_check';
      console.log(url);
      this.$http.post(url)
        .then((resp) => {
          console.log('AppVue :: authCheck :: ', resp);
          if (resp.status === 200) {
            let success = false;
            if (typeof resp.data !== 'undefined' && resp.data.login === 1) success = true;
            if (success) {
              this.$store.commit('SET_USER', resp.data);
              setTimeout(() => {
                this.$router.push('/');
              }, 1000);
            } else {
              this.$store.commit('SET_USER', {});
            }
          } else {
            this.$store.commit('SET_USER', {});
          }
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit('SET_USER', {});
        });
    },
  },
  watch: {
    $route(to) {
      document.title = `Beyond Labz | ${to.name}`;
    },
  },
};
</script>

<style>
.page {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
}
.bg-image {
  background-color: #E0E0E0;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 150ms;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
